// ─── Feuille : créer / éditer une catégorie (rayon) ────────────────
// Toujours une surcharge personnelle (cf. services/ingredientsPerso) — on
// n'écrit jamais sur la base partagée.
import React, { useEffect, useMemo, useState } from 'react';
import { Text, TextInput, StyleSheet } from 'react-native';
import { Feuille, SelecteurEmoji, stylesForm, useUI, useT } from '@mop/core';

const VIDE = { label: '', emoji: '📦' };

export default function FeuilleCategorie({ visible, initial, onEnregistrer, onFermer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => StyleSheet.create({ ...stylesForm(UI) }), [UI]);
  const [f, setF] = useState(VIDE);

  useEffect(() => { if (visible) setF({ ...VIDE, ...(initial || {}) }); }, [visible, initial]);

  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const valide = !!(f.label || '').trim();

  return (
    <Feuille visible={visible} titre={initial?.id ? t('ingredients.modifierCategorie') : t('ingredients.nouvelleCategorie')}
      emoji={f.emoji} hauteur={0.85} onFermer={onFermer}
      action={{ icone: initial?.id ? '💾' : '＋', label: t('commun.enregistrer'), disabled: !valide, onPress: () => onEnregistrer(f) }}>

      <Text style={s.lbl}>{t('commun.nom')}</Text>
      <TextInput style={s.input} value={f.label} onChangeText={v => set('label', v)}
        placeholder={t('ingredients.phCategorie')} placeholderTextColor={UI.faint} />

      <Text style={s.lbl}>{t('commun.emoji')}</Text>
      {/* `inline` : recherche + grille directement dans le flux (plein
          largeur, pas de popup flottant limité en hauteur qui se coupe dans
          une feuille de taille moyenne). */}
      <SelecteurEmoji valeur={f.emoji} onChange={v => set('emoji', v)} avecRecherche inline />
    </Feuille>
  );
}
